import "../style/page/ProductOrderpage.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  productorder,
  productorderid,
  sidebar,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import { ProductOrderGet, pharmacytrackorder } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../assets/images/noimage.png";
import ProductOrderForm from "../form/productorderform";

function ProductOrder(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const [trackorderidp, settrackorderidp] = useState("");
  const [trackorderstatep, settrackorderstatep] = useState(false);
  const [trackorderdatap, settrackorderdatap] = useState([]);
 const[timeString,settimeString]=useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (trackorderidp != "") {
      console.log(trackorderidp,"trackorderidp")
      axios({
        method: "get",
        url: pharmacytrackorder + trackorderidp + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          settrackorderdatap(res.data.data);
          console.log(res);
          var dateTimeString = res.data.data.order.created_date;

// Create a Date object from the string
var dateTime = new Date(dateTimeString);

// Extract hours, minutes, and seconds
var hours = dateTime.getHours();
var minutes = dateTime.getMinutes();
var seconds = dateTime.getSeconds();

// Format the time as a string
settimeString(hours + ":" + minutes + ":" + seconds)

console.log(timeString);
        })
        .catch((error) => {});
    }
  }, [trackorderidp]);
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: ProductOrderGet,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
          },
        })
          .then((res) => {
            console.log(res);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: ProductOrderGet,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
        },
      })
        .then((res) => {
          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, productstate]);

  const dropdownhandlechange = (id, e) => {
    dispatchid(productorderid(id));
    dispatch(productorder("Edit"));
  };

  const columns = useMemo(
    () => [
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.phone_number}
              >
                {String(row.row.original.phone_number)}
              </p>
            </>
          );
        },
      },

      {
        Header: "Assigned By",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_by}
              >
                {String(row.row.original.assigned_by)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Assigned To",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_to}
              >
                {String(row.row.original.assigned_to)}
              </p>
            </>
          );
        },
      },

      {
        Header: "Cart Products",
        accessor: "",
        Cell: (row) => {
          console.log(row.row.original.cart_products)
          const items = [];
          row.row.original.cart_products.pharma!=null&&row.row.original.cart_products.forEach((item) =>
            items.push(item.pharma.product_name)
          );
          // console.log(items.toString());
          const shorten =
            items.toString().length > 20
              ? `${items.toString().substring(0, 15)}...`
              : `${items.toString()}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${items.toString()}`}
              >
                {shorten}{" "}
              </p>
            </>
          );
        },
      },
      {
        Header: "Need Prescription",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.need_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.need_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },
      {
        Header: "No Prescription",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.no_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.no_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.status}
              >
                {row.row.original.status}
              </p>
            </>
          );
        },
      },
      {
        Header: "Total Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.total_amount}
              >
                {parseFloat(row.row.original.total_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.ordercreaterazorpay != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.ordercreaterazorpay.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.ordercreaterazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => {
                    dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };

  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Product Order</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Product Order</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}>
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    stateid={"1"}
                    settrackorderidp={settrackorderidp}
                    settrackorderstatep={settrackorderstatep}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {productstate == "Edit" ? (
        <ProductOrderForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
      {trackorderstatep == true &&
        trackorderdatap != undefined &&
        trackorderdatap != null &&
        trackorderdatap != "" && (
          <>
            <div className="card_parent">
              <div className="card22">
                <span
                  className="cross"
                  onClick={(e) => {
                    settrackorderstatep(false);
                    settrackorderidp("");
                  }}
                >
                  {" "}
                  <div className="title">Track Order Status</div>
                  <i class="bi bi-x-lg x"></i>
                </span>

                <div className="info">
                  <div className="row">
                    <div className="col-7">
                      <span id="heading"> Ordered Date</span>
                      <br />
                      <span id="details">
                        {trackorderdatap.order.created_date != null
                          ? trackorderdatap.order.created_date.slice(0, 10) +'  '+ timeString
                          : ""}
                      </span>
                    </div>
                    <div className="col-5 pull-right">
                      <span id="heading">Delivery Date</span>
                      <br />
                      <span id="details">
                        {trackorderdatap.order.delivery_date != null
                          ? trackorderdatap.order.delivery_date.slice(0, 10)
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tracking">
                  <div className="title">Tracking Order</div>
                </div>
                <div className="progress-track">
                  <ul id="progressbar">
                    <li
                      className={`step0 ${
                        trackorderdatap.order_placed != null &&
                        trackorderdatap.order_placed != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step1"
                    >
                      Comfirming Order<br></br>
                      <div className="time">
                        {trackorderdatap.order_placed != null &&
                        trackorderdatap.order_placed != undefined
                          ? trackorderdatap.order_placed.time
                          : ""}
                      </div>
                    </li>
                    <li
                      className={`step0  text-center ${
                        trackorderdatap.order_packing != null &&
                        trackorderdatap.order_packing != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step2"
                    >
                      <span style={{ marginRight: "20px" }}>
                        Ready To Dispatch<br></br>
                        <div className="time">
                          {trackorderdatap.order_packing != null &&
                          trackorderdatap.order_packing != undefined
                            ? trackorderdatap.order_packing.time
                            : ""}
                        </div>
                      </span>
                    </li>
                    <li
                      className={`step0 text-right ${
                        trackorderdatap.intransit != null &&
                        trackorderdatap.intransit != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step3"
                    >
                      <span style={{ marginRight: "20px" }}>
                        In Transit<br></br>
                        <div className="time">
                          {trackorderdatap.intransit != null &&
                          trackorderdatap.intransit != undefined
                            ? trackorderdatap.intransit.time
                            : ""}
                        </div>
                      </span>
                    </li>
                    <li
                      className={`step0 text-right ${
                        trackorderdatap.orderdelivered != null &&
                        trackorderdatap.orderdelivered != undefined
                          ? "active"
                          : ""
                      }`}
                      id="step4"
                    >
                      Delivered<br></br>
                      <div className="time">
                        {trackorderdatap.order_placed != null &&
                        trackorderdatap.order_placed != undefined
                          ? trackorderdatap.order_placed.time
                          : ""}
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="pricing">
                  <div className="row">
                    <div className="col-9">
                      <span id="name">Name</span>
                    </div>
                    <div className="col-3">
                      <span id="price">Quantity</span>
                    </div>
                  </div>

                  {trackorderdatap.order.cart_products.map((ele, index) => {
                    return (
                      <div className="row">
                        <div className="col-9">
                          {ele.pharma!=null&&<span id="name">
                            {index + 1 + ". " + ele.pharma.product_name}
                          </span>}
                        </div>
                        <div className="col-3">
                          <span id="price">{ele.quantity}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* <div className="total">
                <div className="row">
                  <div className="col-9" />
                  <div className="col-3">
                    <big>£262.99</big>
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </>
        )}
    </>
  );
}

export default ProductOrder;
